/* eslint-disable */
import {
  Form,
  Input,
  Table,
  DatePicker,
  Space,
  Dropdown,
  Button,
  message,
  Tag,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
  useCallback,
} from "react";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import { MenuOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import PasswordResetModal from "./PasswordResetModal";
import AddUserModal from "./AddUserModal";

const { RangePicker } = DatePicker;

const MainTable = forwardRef(({ statusFilter, ...props }, ref) => {
  const [tableList, setTableList] = useState([]);
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [form] = Form.useForm();
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedLastDateRange, setSelectedLastDateRange] = useState(null);
  const [tableHead, setTableHead] = useState({
    usertype: null,
    firstName: null,
    email: null,
    lastName: null,
    phone: null,
    cSTime: null,
    eCTime: null,
    loginCount: null,
    vendorId: null,
    vendorTypeName: null,
    monthlySalary: null,
  });

  const navigate = useNavigate();
  const passwordResetRef = useRef();
  const addUserRef = useRef();

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false }
              : { ...col, hidden: true }
        );
      });
    },
    newListFun: () => {
      fetchData(1, 25);
    },
    showModalAdd: () => {
      addUserRef.current?.showModal();
    },
  }));

  // 统一的表格筛选方法
  const tableFilterFn = useCallback((e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHead = { ...prev, [fieldName]: inputValue };
        fetchData(1, 25, updatedTableHead);
        return updatedTableHead;
      });
    }
  }, []);

  // 日期范围筛选方法
  const handleDateRangeFilter = useCallback((dates, fieldPrefix) => {
    if (dates && dates.length === 2) {
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();
      setTableHead((prev) => {
        const updatedTableHead = {
          ...prev,
          [`${fieldPrefix}STime`]: startTime,
          [`${fieldPrefix}ETime`]: endTime,
        };
        fetchData(1, 25, updatedTableHead);
        return updatedTableHead;
      });
    }
  }, []);

  // 定义列
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      align: "center",
      width: 60,
      render: (text, record) =>
        commonFn.btnAuthorityFlag("UpdatePassword") && (
          <Dropdown
            menu={{
              items: [
                {
                  key: "update",
                  icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Update Password</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
      width: 100,
      align: "center",
      render: (text) => (
        <Tag color={text == 1 ? "green" : "blue"}>
          {text == 1 ? "tenant" : "vendor"}
        </Tag>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "email"),
      render: (text) => text,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      titleType: "Input",
      align: "center",
      width: 100,
      onChange: (e) => tableFilterFn(e, "firstName"),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      titleType: "Input",
      align: "center",
      width: 200,
      onChange: (e) => tableFilterFn(e, "lastName"),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      titleType: "Input",
      width: 150,
      onChange: (e) => tableFilterFn(e, "phone"),
    },
    {
      title: "Vendor Id",
      dataIndex: "vendorId",
      key: "vendorId",
      titleType: "Input",
      align: "center",
      width: 100,
      onChange: (e) => tableFilterFn(e, "vendorId"),
    },
    {
      title: "Vendor Type",
      dataIndex: "vendorTypeName",
      key: "vendorTypeName",
      titleType: "Input",
      align: "center",
      width: 100,
      onChange: (e) => tableFilterFn(e, "vendorTypeName"),
    },
  {
  title: "Monthly Cost",
  dataIndex: "monthlySalary",
  key: "monthlySalary",
  titleType: "Input",
  align: "center",
  width: 150,
  isAmountFlag: true,  
  onChange: (e) => tableFilterFn(e, "monthlySalary"),
},
    {
      title: (text, record, index) => (
        <div>
          <div>Last Login Time</div>
          <Space direction="vertical">
            <RangePicker
              onChange={(dates) => handleDateRangeFilter(dates, "l")}
              format="MM/DD/YYYY"
            />
          </Space>
        </div>
      ),
      dataIndex: "lastLoginTime",
      key: "lastLoginTime",
      width: 150,
      align: "center",
      isDate: true,
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
    {
      title: "Login Count",
      dataIndex: "loginCount",
      key: "loginCount",
      titleType: "Input",
      align: "center",
      width: 100,
      onChange: (e) => tableFilterFn(e, "loginCount"),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Create Time</div>
          <Space direction="vertical">
            <RangePicker
              onChange={(dates) => handleDateRangeFilter(dates, "c")}
              format="MM/DD/YYYY"
            />
          </Space>
        </div>
      ),
      dataIndex: "createTime",
      key: "createTime",
      width: 200,
      align: "center",
      isDate: true,
      render: (text, record, index) =>
        text ? moment(text).format("MM/DD/YYYY HH:mm") : " ",
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 处理动态展示列
  const shouldHideVendorColumns = filteredData.some((item) => item.userType === 1);

  const visibleColumns = columns
    .map((column) => {
      if (["vendorId", "vendorTypeName", "monthlySalary"].includes(column.key)) {
        return {
          ...column,
          hidden: shouldHideVendorColumns,
        };
      }
      if (["email", "firstName", "lastName", "phone", "loginCount"].includes(column.dataIndex)) {
        return {
          ...column,
          hidden: false,
        };
      }
      return column;
    })
    .filter((col) => !col.hidden);

  // Action菜单点击
  const handleMenuClick = async (e, record) => {
    if (e.key === "update") {
      passwordResetRef.current?.showModal(record);
    }
  };

  // 初始化数据
  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, [statusFilter]);

  // 获取列表数据
  const fetchData = async (page, pageSize, tableHead) => {
    setTableLoading(true);
    try {
      const params = {
        page,
        count: pageSize,
        email: tableHead?.email || "",
        firstName: tableHead?.firstName || "",
        lastName: tableHead?.lastName || "",
        phone: tableHead?.phone || "",
        userType: statusFilter === "vendor" ? 2 : 1,
        eCTime: tableHead?.eCTime || "",
        cSTime: tableHead?.cSTime || "",
        lSTime: tableHead?.lSTime || "",
        lETime: tableHead?.lETime || "",
        loginCount: tableHead?.loginCount || "",
        vendorId: tableHead?.vendorId || "",
        vendorTypeName: tableHead?.vendorTypeName || "",
        monthlySalary: tableHead?.monthlySalary || "",
      };

      const response = await http.get(api.getAppUserList, { params });

      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.userId,
      }));
      setTableList(dataWithKey);
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total,
        pageSize: pageSize,
      }));
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 刷新列表回调
  const handleRefresh = () => {
    fetchData(pagination.current, pagination.pageSize);
  };

  return (
    <div>
      <CustomTable
        tableLoading={tableLoading}
        columns={visibleColumns}
        tableList={filteredData}
        pagination={pagination}
        rowKey="userId"
        handleTableChange={(pagination, filters, sorter) => {
          fetchData(pagination.current, pagination.pageSize);
        }}
        setTableHead={setTableHead}
        getTableListFn={fetchData}
        // tableCss="my-Table"
        tableScrollY="340px"

      />

      {/* 修改密码Modal */}
      <PasswordResetModal ref={passwordResetRef} />

      {/* 新增用户Modal */}
      <AddUserModal ref={addUserRef} onSuccess={handleRefresh} />
    </div>
  );
});

export default MainTable;